export default "__VITE_ASSET__dcd467aa__"